<template>
    <div class="gray-back" style="padding:.2rem 0 1rem 0">
        <van-form
                @submit="onSubmitCheck"
                @failed="onFailed"
        >
            <div v-for="(subject,index) in row.subject_list " :key="index">

                <van-divider>项目信息{{index+1}}
                </van-divider>

                <van-cell-group>

                    <van-cell
                            readonly
                            clickable
                            is-link
                            input-align="right"
                            title="项目"
                            value="请选择项目"
                            @click="openSubjectPicker(subjectOptionsAll,index)"
                    />
                    <div class="operate-desc-left" v-show="subject.subject_name">{{subject.subject_name}}</div>


                    <van-cell v-if="subject.music_url" title="规定音乐" value="点击试听" @click="playMusicUrl=subject.music_url;subject.music_url_played=true;showMusic=true"  is-link>
                    </van-cell>
                    <!-- <van-cell v-else v-show="row.is_online!=1" title="上传音乐" value="上传音乐" @click="musicUrlShow=true"   is-link>
                    </van-cell> -->

                    <!--<van-action-sheet v-model="showSubjectPicker"
                                      :actions="subjectOptions"
                                      @click-overlay="onSubjectClose"
                                      @select="onSubjectSelect" />-->

                    <van-popup v-model="showSubjectPicker"   @click-overlay="onSubjectClose"  :style="{ width: '80%',paddingTop:'50px' }" >
                        <van-cell-group>
                            <van-cell  v-if="subjectOptions.length > 0" v-for="(item,index) in subjectOptions" :key="index" is-link @click="onSubjectSelect(item)">{{item.name}}</van-cell>
                            <van-cell v-if="subjectOptions.length == 0">请先绑定俱乐部</van-cell>
                        </van-cell-group>

                    </van-popup>
     

                </van-cell-group>

                <div style="text-align: center">
                    <van-button
                            native-type="button"
                            style="width: 3rem;"
                            size="normal" round icon="close"   @click="subjectRemove(subject,index)">删除项目{{index+1}}</van-button>
                </div>
            </div>


            <div style="text-align: center">
                <van-button
                        native-type="button"
                        style="width: 3rem; margin-top: 0.4rem"
                        size="normal" round  icon="plus"   @click="subjectAdd">新增项目</van-button>

                <van-button
                v-if="false"
                        native-type="button"
                        style="width: 3.5rem; margin-top: 0.4rem"
                        size="normal" round  icon="share"   @click="show_share_panel=true">分享给家长填写</van-button>
            </div>

            <div style="height: 100px"></div>

            <div class="savebtn">
              <van-button
                  color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                  style="width: 3rem"
                  size="normal" round  native-type="button" v-rblink="{name:'ISaiApplyFormStep1',query:{id:this.$route.query.id}}">上一步</van-button>
                <van-button
                        color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                        style="width: 3rem"
                        size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..." @click="submit">保存</van-button>
            </div>
        </van-form>


        <div class="shareShow" v-if="showWxShare" @click="showWxShare=false">
            <div>
                <h2>点击分享给好友(朋友圈)</h2>
            </div>
        </div>


        <van-popup v-model="show_share_panel" position="bottom" :style="{ height: '30%' }" >
            <div class="share-panel">
                <div class="share-title">请选择分享方式</div>
                <!--<div class="share-desc">朋友通过你分享的页面成功报名后，你可获得对应的佣金。佣金可在会员中心-分销订单里查看</div>-->
                <div class="share-ul">
                    <div class="share-weixin" @click="shareWeixinFriend">
                        <p>微信好友</p>
                    </div>
                    <div class="share-timeline" @click="shareWeixinTimeLine">
                        <p>朋友圈</p>
                    </div>
                    <div class="share-copy" v-clipboard:copy="copy_text" v-clipboard:success="function(){copySuccess();show_share_panel=false }" >
                        <p>复制链接</p>
                    </div>
                </div>
            </div>
        </van-popup>
 
        <van-popup
                v-model="showMusic"
                closeable
                position="bottom"
                :style="{ height: '30%' }"
        >
            <div style="text-align: center">
                <audio autoplay style="margin: 10px auto" v-if="playMusicUrl&&showMusic" :src="playMusicUrl" controls="controls"></audio>
            </div>
        </van-popup>
      <van-dialog v-model="showError" title="项目错误信息" style="max-height: 80%;overflow-y: scroll">
        <van-cell-group>
          <van-cell :title="item" v-for="item in errorMsg"/>
        </van-cell-group>
      </van-dialog>

      <van-dialog v-model="musicUrlShow" title="请在复制网址到电脑端操作" confirm-button-text="关闭" >
                <div style="text-align: center; padding:20px 0 ; line-height: 30px ">
                    <div
                            v-clipboard:copy="row.music_edit_url"
                            v-clipboard:success="onCopy"
                            v-clipboard:error="onError">
                        {{row.music_edit_url}}  <br/> <span  >复制</span>
                    </div>
                </div>
            </van-dialog>

    </div>
</template>
<style scoped>
    .box {
        /*margin-bottom: 1.5rem;*/
    }

    .memberResultWrap{
        background: #F3F3F3;
        margin: 0.2rem;
        border-radius: 8px;
        padding: 0.2rem;
    }
    .memberResultWrap .memberLi{
        font-size: 14px;
        color: #666;
        height: 36px;
        line-height: 36px;
    }
    .memberResultWrap .memberLi .van-tag{
        width: auto !important;
    }

    .savebtn {
        position: fixed;
        bottom: 0;
        padding-bottom: 0.2rem;
        width: 100%;
        z-index: 10;
        display: flex;
        flex: 1;
        flex-direction: row;
        justify-content: space-around;
        background: linear-gradient(180deg,hsla(0,0%,100%,0),#fff);
    }


    .van-tag {
        width: 55px;
        margin-left: 10px;
        text-align: center;
    }
    .between {
        justify-content: space-between;
    }

</style>
<script>
    import Vue from 'vue';
    import area from "../../../utils/area";
    import validator from "../../../utils/validator";
    import PicUploader from '@/components/picker/PicUploader.vue';
    import FileUploader from '@/components/picker/FileUploader.vue';

    import {Cell,Field,Area,Form,Divider, CellGroup,RadioGroup,Radio,Dialog,ActionSheet,Icon, Toast, Popup, Picker, Sidebar, SidebarItem, Tag, Stepper ,Switch ,Button} from 'vant';

    import SubjectJiaolianPicker from '@/components/picker/SubjectJiaolianPicker.vue'; 
    import SubjectYundongyuanPicker from '@/components/picker/SubjectYundongyuanPicker.vue';

    Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Area).use(ActionSheet).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
            .use(Switch).use(Button).use(Dialog);
    export default {
        name: 'SaiApplyFormStep2',
        components: {
            [Field.name]: Field,
            PicUploader,
            FileUploader,
            SubjectJiaolianPicker,
            SubjectYundongyuanPicker,
        },
        data: function () {
            return {
                validator,
                playMusicUrl:'',
                showMusic:false,
              showError:false,
                thisSubjectIndex:0,
                saveLoading:false,
                musicUrlShow:false,
                showWxShare:false,
                showSubjectPicker:false,
                showNumTypePicker:false,
                show_share_panel:false,
                numTypeColumns: ['身份证', '护照'],
                showArea:false,
                areaList:{},
                copy_text:'cccc',
                areaValue:'',
                submitType:'',
                subject_name:'',
              errorMsg: [],
                subjectArray:[],
                subjectOptions:[],
                subjectOptionsAll: [
                    {
                        name: '幼儿组',
                        children: [
                            {
                                name: '幼儿组',
                                children: [{ name: '舞蹈啦啦操',
                                    children:[
                                        {
                                            name: '花球规定动作',
                                        },
                                        {
                                            name: '222',
                                        }
                                    ] }, {
                                    name: '余杭区',
                                    children:[
                                        {
                                            name: '111',
                                        },
                                        {
                                            name: '222',
                                        }
                                    ]
                                }],
                            },
                            {
                                name: '温州',
                                children: [{ name: '鹿城区' }, { name: '瓯海区' }],
                            },
                        ],
                    },
                    {
                        name: '福建',
                        children: [
                            {
                                name: '福州',
                                children: [{ name: '鼓楼区' }, { name: '台江区' }],
                            },
                            {
                                name: '厦门',
                                children: [{ name: '思明区' }, { name: '海沧区' }],
                            },
                        ],
                    },
                ],
                row:{
                    subject_list:[],
                    subject_options:[],
                },
                formData: {
                    id: 0,
                    saiqu_name:'xxxxx',
                    danwei:'xxxxx',
                    caipan:[],
                    music:[],
                    yundongyuan:[],
                    tbydy:[],
                    jiaolian:[],
                    areas:'',
                    province:'',
                    city:'',
                    county:'',
                    kaojitype:'考级中心',
                    changdipic: [{"uid":"vc-upload-1587109262602680","url":"https://cheeseman.oss-cn-hangzhou.aliyuncs.com/h5/2020-04-17/1587109262602680.jpg","name":"支付宝.jpg","save_name":"h5/2020-04-17/1587109262602680.jpg"}],
                    zhizhaopic: [{"uid":"vc-upload-1587109262602680","url":"https://cheeseman.oss-cn-hangzhou.aliyuncs.com/h5/2020-04-17/1587109262602680.jpg","name":"支付宝.jpg","save_name":"h5/2020-04-17/1587109262602680.jpg"}],
                },
            }
        },
        mounted() {
            document.title = '项目填写';
            let that = this;
            that.areaList = area;
            that.formData.id = this.$route.query.id;
            if(that.formData.id){
                this.fetch();
            }
        },
        watch: {
            formData() {
            }
        },
        destroyed() {
        },
        filters:{
          sex : function(val){
              switch (val){
                  case 1 : return '男';
                  case 2 : return '女';
                  default : return ''
              }
          }
        },
        methods: {
            onQuestion(){
                console.log('onQuestion')
            },
            subjectAdd(){
                this.row.subject_list.push({
                    showYundongyuanPicker:false,
                    showTbYundongyuanPicker:false,
                    showJiaolianPicker:false,
                    subject_name:'',
                    subjectArray:[],
                    yundongyuan:[],
                    tbydy:[],
                    music:[],
                    jiaolian:[],
                })
            },
            subjectRemove(item,index){
                let that = this;
                let notice = '确认删除项目'+(item.subject_name?'('+item.subject_name+')':'')+'吗?';
                Dialog.confirm({
                    title: '确认',
                    message: notice
                })
                        .then(() => {
                            // on confirm
                            console.log('subjectRemove');

                            if(!item.id){
                                that.row.subject_list.splice(index,1);
                                return
                            }

                            that.$api.post('/api/isai/subjectDelete', {
                                'baoming_id' : that.row.id,
                                'subject_id' : item.id
                            }, (res) => {

                                that.row.subject_list.splice(index,1);
                            }, (res) => {
                                Toast.fail(res.msg);
                            })

                        })
                        .catch(() => {
                            // on cancel
                        });
            },
            openSubjectPicker(option,index){
                this.showSubjectPicker = true;
                this.thisSubjectIndex = index;
                this.subjectOptions = option;

                this.row.subject_list[this.thisSubjectIndex].subject = undefined;
                this.row.subject_list[this.thisSubjectIndex].subjectArray = [];
                this.row.subject_list[this.thisSubjectIndex].subject_name = '';
            },
            onSubjectClose(){
                this.showSubjectPicker = false;
                this.row.subject_list[this.thisSubjectIndex].subject = undefined;
                this.row.subject_list[this.thisSubjectIndex].subjectArray = [];
                this.row.subject_list[this.thisSubjectIndex].subject_name = '';
            },
            onSubjectSelect(item){
                    console.log(item);
                    this.row.subject_list[this.thisSubjectIndex].subjectArray.push(item);
                    this.row.subject_list[this.thisSubjectIndex].subject_name = this.row.subject_list[this.thisSubjectIndex].subjectArray.map(item => {
                        return item.name
                    }).join('-')
                    if(!item.children || item.children.length==0){
                        this.showSubjectPicker = false;
                        this.onShowMusic();
                        return false;
                    }
                    this.subjectOptions = item.children;
            },
            onShowMusic(){
                let item =this.row.subject_list[this.thisSubjectIndex];
                let subject = item.subjectArray[item.subjectArray.length-1].key
                let that =this;
                console.log('onShowMusic',subject);
                that.$api.post('/api/isai/getSubjectMusic', {
                    subject:subject,
                  saiqu: that.row.saiqu
                }, (res) => {
                    console.log(res);
                    that.$set(this.row.subject_list[this.thisSubjectIndex],'music_url',res.data.music_url);
                    that.$set(this.row.subject_list[this.thisSubjectIndex],'music_url_played',false);
                }, (res) => {
                    console.log(res);
                    that.$set(this.row.subject_list[this.thisSubjectIndex],'music_url','');
                });
            },
            onYundongyuanConfirm(values){
                console.log('onYundongyuanConfirm',values)
              // 判断替补运动员是否已存在
              let count = 0
              this.row.subject_list[this.thisSubjectIndex].tbydy.map(member => {
                values.map(row => {
                  if(member.name == row.name) {
                    Toast.fail(row.name + " 替补运动员中已存在")
                    count++
                    return
                  }
                })
              })
//                this.showYundongyuanPicker = false;
                this.row.subject_list[this.thisSubjectIndex].showYundongyuanPicker = false;
              if(count > 0) return
              this.row.subject_list[this.thisSubjectIndex].yundongyuan = [...values];
            },
            onYundongyuanChange(values){
                console.log('onYundongyaunChange',values)
              // 判断替补运动员是否已存在
              let count = 0
              this.row.subject_list[this.thisSubjectIndex].tbydy.map(member => {
                values.map(row => {
                  if(member.name == row.name) {
                    Toast.fail(row.name + " 替补运动员中已存在")
                    count++
                    return
                  }
                })
              })
              if(count > 0) return
              this.row.subject_list[this.thisSubjectIndex].yundongyuan = [...values];
            },
            onTbYundongyuanConfirm(values){
                console.log('onTbYundongyuanConfirm',values)
              // 判断参赛运动员是否已存在
              let count = 0;
              this.row.subject_list[this.thisSubjectIndex].yundongyuan.map(member => {
                values.map(row => {
                  if(member.name == row.name) {
                    Toast.fail(row.name + " 参赛运动员中已存在")
                    count++
                    return
                  }
                })
              })
                this.row.subject_list[this.thisSubjectIndex].showTbYundongyuanPicker = false;
              if(count > 0) return
              this.row.subject_list[this.thisSubjectIndex].tbydy = [...values];
            },
            onTbYundongyuanChange(values){
                console.log('onTbYundongyuanChange',values)
              // 判断参赛运动员是否已存在
              let count = 0;
              this.row.subject_list[this.thisSubjectIndex].yundongyuan.map(member => {
                values.map(row => {
                  if(member.name == row.name) {
                    Toast.fail(row.name + " 参赛运动员中已存在")
                    count++
                    return
                  }
                })
              })
              if(count > 0) return
                this.row.subject_list[this.thisSubjectIndex].tbydy = [...values];
            },
            onJiaolianConfirm(values){
                console.log('onJiaolianConfirm',values)
                this.row.subject_list[this.thisSubjectIndex].showJiaolianPicker = false;
                this.row.subject_list[this.thisSubjectIndex].jiaolian = [...values];
            },
            onJiaolianChange(values){
                console.log('onJiaolianChange',values)
                this.row.subject_list[this.thisSubjectIndex].jiaolian = [...values];
            },
            onNumTypeConfirm(value, index){
                this.row.subject_list[this.thisSubjectIndex].numTypeName = value;
                this.row.subject_list[this.thisSubjectIndex].numtype = index+1;
                this.showNumTypePicker = false;
            },
            onSubmitCheck(values) {
              Dialog.confirm({
                title: '确认提交',
                message: '是否需要补报项目？',
                showCancelButton: true,
                confirmButtonText: '我没有项目要报了',
                cancelButtonText: '我还有项目要报',
              }).then(() => {
                // on confirm
                this.onSubmit(values)
              })
                  .catch(() => {
                    // on cancel
                  });
            },

            onSubmit(values){
                console.log('onSubmit-values',values);
                console.log('submitType',this.submitType);

                let that = this;
                console.log(that.formData)
                that.formValidate = true;
                for (let field in that.formData) {

//                    if (that.formData.changdipic.length == 0) {
//                        Toast('请上传场地照片');
//                        return
//                    }
                }
                let valiOk = true;

                that.row.subject_list.map((item,index) =>{
                    if(!item.subject  && item.subjectArray.length==0){
                        Toast('请选择项目'+(index+1));
                        valiOk = false;
                        return ;
                    }
                    if(item.yundongyuan.length==0 && item.subject_name.indexOf('活力大课间啦啦操展示')==-1){
                        // Toast('请完善项目'+(index+1)+'的运动员信息');
                        // valiOk = false;
                        return ;
                    }
                    if(item.jiaolian.length==0){
                        // Toast('请完善项目'+(index+1)+'的教练员信息');
                        // valiOk = false;
                        return ;
                    }
                    if(item.music_url_played==false && item.music_url){
                        Toast('请试听项目'+(index+1)+'的规定音乐');
                        valiOk = false;
                        return ;
                    }
                });
                if(!valiOk){
                    return ;
                }


                that.saveLoading = true;
 

                that.onDataSave()

            },
            onDataSave() {
              let that = this 
              that.$api.post('/api/isaidianxin/subjectsave', {
                'baoming_id' : that.row.id,
                'subject_list' :JSON.stringify( that.row.subject_list.map(item =>{
                  return {
                    'id' : item.id||0,
                    'subject_name' : item.subject_name,
                    'subject' : item.subject||item.subjectArray[item.subjectArray.length-1].key,
                    'yundongyuan' : item.yundongyuan,
                    'jiaolian' : item.jiaolian,
                    'tbydy' : item.tbydy,
                    'music' : item.music,
                  }
                }))
              }, (res) => {

                appEvent({
                  name: 'saiApplyDetailReload',
                  query: {
                  }
                });

                console.log('back')
 
                //电信赛
                rbLink({
                    name:'ISaiApplyVideoList',
                    'query':{
                        id:that.row.id,
                    }
                },'replace')
                return  
                
              }, (res) => {
                Toast.fail(res.msg);
                that.saveLoading = false;
              })
            },


            save(values){
                this.submitType = 'save';
            },
            onFailed(errorInfo){
                console.log('failed', errorInfo);
            },
            submit(values) {
                this.submitType = 'submit';
            },
            fetch(){
                let that = this;
                that.$api.post('/api/isai/step2detail', {
                    id:that.formData.id
                }, (res) => {
                    that.row = res.data;
                    that.subjectOptionsAll = res.data.subject_options;
                    that.copy_text=res.data.share_data.url;
                //showYundongyuanPicker
                    that.row.subject_list.map(item =>{
                                that.$set(item,'subjectArray',[]);
                                that.$set(item,'showYundongyuanPicker',false);
                                that.$set(item,'showTbYundongyuanPicker',false);
                                that.$set(item,'showJiaolianPicker',false);
                                that.$set(item,'music_url',item.subject_music.music_url? item.subject_music.music_url:'');
                                that.$set(item,'music_url_played',false);
                    });

                    that.wxShare(that.row.share_data.title,that.row.share_data.desc,that.row.share_data.url,that.row.share_data.pic_url );
                }, (res) => {
                    Toast.fail(res.msg);
                })
            },


            shareWeixinFriend(){
                console.log('shareWeixinFriend')
                let that = this;
                if(window.isApp()){
                    appEvent({
                        name: 'shareWeixinFriend',
                        query: that.row.share_data,
                    });
                }else{
                    this.showWxShare = true;
                    this.show_share_panel = false;
                }
            },
            shareWeixinTimeLine(){
                let that = this;
                if(window.isApp()){
                    appEvent({
                        name: 'shareWeixinTimeLine',
                        query: that.row.share_data
                    });
                }else{
                    this.showWxShare = true;
                    this.show_share_panel = false;

                }
            },

            onCopy(e) {
                Toast.success('复制成功');
            },
            onError(e) {
                console.log('复制失败！');
            },


        }
    }
</script>



// WEBPACK FOOTER //
// SaiApplyFormStep2Dianxin.vue?439c1a11